module.exports = __webpack_public_path__ + "img/pannel_icon.72223944.svg";